import fullpage from 'fullpage.js/dist/fullpage.extensions.min.js';

if ( document.querySelector('#primary') ) {
    init();

    window.addEventListener('resize', debounce(() => {
        rebuild();
    }));
}

function init() {
    const links = document.querySelectorAll('#primary-menu li a[href*="#"]');

    let slideIndexS = 0,
        sliding = false;

    console.log(window.innerHeight);
    let options = {
        licenseKey: '791L9-GJTQ9-NKK5I-N4J08-YWVRN',
        scrollOverflow: window.innerHeight < 900,
        controlArrows: false,
        scrollHorizontally: true,
        slidesNavigation: true,
        bigSectionsDestination: top,
        afterResize: function() {
            //fullpage_api.reBuild(true);
        },
        afterLoad: function(origin, destination){
            links.forEach((link) => {
                link.classList.remove('active');

                if (destination.item.id && link.hash.replace('#', '') === destination.item.id) {
                    link.classList.add('active');
                }
            });
        },
        afterSlideLoad: function(section, origin, destination){
            slideIndexS = destination.index + 1;
        },
        onLeave: function(origin, destination, direction) {
            if (origin.index === 1 && !sliding) {
                if (direction === 'down' && slideIndexS < 3) {
                    fullpage_api.moveSlideRight();
                    return false;
                } else if (direction === 'up' && slideIndexS > 1) {
                    fullpage_api.moveSlideLeft();
                    return false;
                }
            }
        }
    };

    if (window.innerHeight < 900) {
        options.paddingTop = '12rem';
        options.paddingBottom = '4rem';
    }

    const sectionEls = document.querySelectorAll('.section');
    let sections = [];

    sectionEls.forEach((sectionEl, index) => {
        if (sectionEl.id) {
            sections.push({
                index: index +1,
                id: sectionEl.id,
            });
        }
    });

    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const section = sections.find((section) => section.id === link.hash.replace('#', ''));
            if (section) {
                sliding = true;
                fullpage_api.moveTo(section.index);
                setTimeout(function() {
                    sliding = false;
                }, 100);
            }
        });
    });

    new fullpage('#primary', options);

    let postsSlider = document.querySelector('.block--post-cards-slider');
    let slideTitles = postsSlider.querySelectorAll('.slide .block__post-cards__item__text > h2');
    let titles = [];
    slideTitles.forEach((slideTitle) => {
        titles.push(slideTitle.innerHTML);
    });

    let postsSliderNavA = postsSlider.querySelectorAll('.fp-slidesNav li a');

    postsSliderNavA.forEach((postsSliderNav, index) => {
        postsSliderNav.innerHTML = titles[index];
    });
}

function rebuild() {
    fullpage_api.destroy('all');
    init();
}

function debounce(func, time = 150){
    let timer;
    return function(event){
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
}